import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RespondToActivationRequest } from '../../../models';
import { RespondToActivationRequestService } from '../../../services';
import { DeclineFormComponent } from './decline-form.component';

@Component({
  selector: 'nexweb-declination',
  templateUrl: './declination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeclineFormComponent, AsyncPipe],
})
export class DeclinationComponent implements OnInit {
  @Input() bidId: number;

  public notification$: Observable<RespondToActivationRequest.Notification>;
  public labels: RespondToActivationRequest.NotificationLabels;
  public dateTimeFormat: string;
  public heading: string;

  private respondToActivationRequestService = inject(RespondToActivationRequestService);
  private bmFacade = inject(BmDataAccessFacade);

  ngOnInit(): void {
    this.labels = this.respondToActivationRequestService.getDeclinationLabels();
    this.dateTimeFormat = this.respondToActivationRequestService.getDateTimeFormat();
    this.heading = this.respondToActivationRequestService.getDeclinationHeading();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.notification$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          instrument: bidNotificationInfo.instrument,
          activatingPortfolio: bidNotificationInfo.requestingTsoPortfolioName,
          supplyingBspPortfolio: bidNotificationInfo.supplyingBspPortfolioName,
          activatedQuantity: bidNotificationInfo.requestedQuantity,
          timeRequestWasDeclined: bidNotificationInfo.rejectTime,
          reasonForDeclining: bidNotificationInfo.rejectReason,
        } as RespondToActivationRequest.Notification;

        return bidNotificationData;
      }),
    );
  }
}
